import connect from './connect'
import EditMeasurementsModal from './EditMeasurementsModal'

export default connect(EditMeasurementsModal)
